export default "https://cdn-static.gokick.com/assets/510b01776e4307c2b342e37a2ed4ce502ef69aad/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";